import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { ROLES_REQUIRING_APPROVER } from "@store/constants";
import { getPolicies, getRole } from "@store/helpers/user";
import sameArrayValues from "@store/utilities/sameArrayValues";

export function hasChanges(state: ApplicationState) {
    const {
        userSetup: { userId, editingUser },
    } = state.pages;
    const user = getAccountState(state, userId).value;
    if (!user || !editingUser) {
        return false;
    }

    const editingRole = getRole(editingUser); // Poolcorp Custom Code

    return (
        user.email !== editingUser.email ||
        user.firstName !== editingUser.firstName ||
        user.lastName !== editingUser.lastName ||
        (editingRole && user.role !== editingRole) || // Poolcorp Custom Code
        user.approver !== editingUser.approver ||
        user.isApproved !== editingUser.isApproved ||
        !sameArrayValues(getPolicies(user), getPolicies(editingUser)) // Poolcorp Custom Code
    );
}
// Poolcorp Custom Code
export function needsApprover(state: ApplicationState) {
    const {
        userSetup: { editingUser },
    } = state.pages;
    if (!editingUser) {
        return false;
    }
    const userRoleRequiresApprover = ROLES_REQUIRING_APPROVER.includes(editingUser?.role ?? "");
    return userRoleRequiresApprover && !editingUser?.approver;
}
